import { DataArray, IDataArray } from "./../../shared/index";
import { PoweredBy, Classification, Project } from "./../index";

export class Model implements IDataArray {
  public Id = 0;
  public Name = "";
  public ClassificationId: string;
  public Active: boolean;
  public AttributeId: number;
  public Live: boolean;
  public Is_Live: boolean;
  public Is_Deleted: boolean;
  public Is_Published: boolean;
  public PoweredBys: DataArray<PoweredBy> = new DataArray<PoweredBy>(1);
  public Status: number;
  public Is_Changed: boolean;
  public Classification: Classification = new Classification();
  public ProjectStaged: Project = new Project();

  constructor() {
    this.Is_Published = false;
    this.Is_Live = true;
  }
  public GetById(): number {
    return this.Id;
  }
}
